<template>
  <v-number-input
    v-model.number="context.value.value[props.field.key]"
    :label="label"
    :prepend-inner-icon="props.field.properties.icon"
    :placeholder="placeholder"
    :step="step"
    :min="minValue"
    :max="maxValue"
    :hint="hint"
    :persistent-hint="true"
    control-variant="stacked"
  />
</template>

<script setup lang="ts">
import { useFormKitContext } from '@formkit/vue'
import { computed, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'

import type { SchemaFormKitProps } from './types'

const { t, te } = useI18n()
const context = useFormKitContext()
const props = defineProps<SchemaFormKitProps>()

const label = computed(() => {
  if (!props.field.properties?.label) return ''

  return te(props.field.properties.label)
    ? t(props.field.properties.label)
    : props.field.properties.label
})

const placeholder = computed(() => {
  if (!props.field.properties?.placeholder) return label.value

  return te(props.field.properties.label)
    ? t(props.field.properties.placeholder)
    : props.field.properties.placeholder
})

const step = computed(() => {
  return props.field.properties?.step ?? 1
})

const minValue = computed(() => {
  return props.field.properties?.min ?? -Infinity
})

const maxValue = computed(() => {
  return props.field.properties?.max ?? Infinity
})

const hint = computed(() => {
  let hints = []
  if (minValue.value !== -Infinity) {
    hints.push(`min: ${minValue.value}`)
  }
  if (maxValue.value !== Infinity) {
    hints.push(`max: ${maxValue.value}`)
  }
  if (step.value !== 1) {
    hints.push(`step: ${step.value}`)
  }
  return hints.join(' | ')
})

onMounted(() => {
  const val = context.value.value[props.field.key] as string | number
  if (typeof val === 'string') {
    const n = parseFloat(val)
    if (!isNaN(n)) {
      let rounded = n
      if (step.value > 0) {
        rounded = Math.round(n * (1 / step.value)) / (1 / step.value)
      }
      context.value.value.value[props.field.key] = rounded
    }
  }
})
</script>
